import React, { memo, useEffect, useState } from "react";
import Api from "Api";
import { Div, Img, Txt } from "Components/GenericView";
import PackageTransactionItem from "./PackageTransactionItem";

const PackageTransactions: React.FunctionComponent<any> = (props) => {
  const { packageId } = props;
  const [appLinkCopyMsg, setappLinkCopyMsg] = useState(false);
  const [appLinkSendMsg, setappLinkSendMsg] = useState(false);
  const [data, setData] = useState(null);

  const apiData = (data || {}) as any;
  const items = apiData?.transactions || [];
  const link = apiData?.package_details?.package_transaction_link || "";
  const isExpire = apiData?.package_details?.is_expiredfalse;
  useEffect(() => {
    if (appLinkCopyMsg || appLinkSendMsg) {
      setTimeout(() => {
        setappLinkCopyMsg(false);
        setappLinkSendMsg(false);
      }, 2000);
    }
    if (!data) getPackageList();
  }, [appLinkCopyMsg, appLinkSendMsg, data]);

  const handleApplinkCopy = () => {
    navigator.clipboard.writeText(link);
    setappLinkCopyMsg(true);
  };
  const handleLinkSend = () => {
    Api.POST(
      `careowner/send_package_transaction_link`,
      {
        package_id: packageId,
      },
      (resp?: any) => {
        if (resp?.status === 200) {
          setappLinkSendMsg(true);
        }
      },
      true,
      true
    );
  };

  const getPackageList = () => {
    Api.GET(
      "careowner/package_transactions/" + packageId,
      (resp?: any) => {
        if (resp?.status === 200) {
          setData(resp?.data?.data);
        }
      },
      true,
      true
    );
  };

  return (
    <Div className="package-transaction">
      <div className="bg-img">
        <Div>
          <Div
            height={27}
            pl="12px"
            pr="12px"
            br={13.5}
            bg="#fff"
            className="active-tab"
            h
            vc
          >
            <Txt
              bg={isExpire ? "#C9C9C9" : "#7ED321"}
              br={5}
              width={10}
              height={10}
            />
            <Txt ml={5.5} fs={14}>
              {isExpire ? "Expired" : "Active"}
            </Txt>
          </Div>
        </Div>
      </div>
      <Div margin={"24px 17.5px 17.5px 17.5px"}>
        <Div mt={23} pt={23} className="wa-tr">
          <Div className="flex justify-between center">
            <Div fs={16} color={"#22234E"}>
              <Txt fs={14} color="#757588">
                Transactions for
              </Txt>
              <Txt color="#22234E" fs={22} mt={5}>
                {apiData?.package_details?.name || ""}
              </Txt>
            </Div>
            <Div h vc relative>
              {(appLinkCopyMsg || appLinkSendMsg) && (
                <Div
                  className="flex align-center fs-14 message app-link-w"
                  pl="11px"
                >
                  <img
                    src={
                      appLinkSendMsg
                        ? "/self-serve/sent@3x.png"
                        : "/self-serve/copy-message@3x.png"
                    }
                    alt="icon"
                    height={13}
                    width={15}
                  />
                  <span className="fs-12 ml-1 mt-1" >
                    {appLinkSendMsg
                      ? "Transaction link has been sent to the Care Owner"
                      : "Package Transaction link copied to clipboard"}
                  </span>
                </Div>
              )}
              <Txt color="#757588" fs={12}>
                Share link to CO:
              </Txt>
              <Div
                pointer
                onClick={handleApplinkCopy}
                br={4}
                p={"4px 5px 0px 5px"}
                ml={7}
                className="link-icon"
              >
                <Img
                  src="/self-serve/copy_icon@3x.png"
                  height={16}
                  width={14}
                  pointer
                />
              </Div>
              <Div
                pointer
                onClick={handleLinkSend}
                className="link-icon"
                br={4}
                p={"4px 5px 0px 5px"}
                ml={4}
              >
                <Img src="/self-serve/mail@3x.png" height={14} width={18} />
              </Div>
            </Div>
          </Div>
          <Div overflowY mt={10}>
            {items.map((item: any, index: number) => (
              <Div key={index}>
                <PackageTransactionItem item={item} />
              </Div>
            ))}
          </Div>
        </Div>
      </Div>
    </Div>
  );
};

export default memo(PackageTransactions);
